import {IonImg,} from '@ionic/react';
import * as React from 'react';
import {RefObject} from 'react';

import Page from "../../../components/core/Page";
import './home-page.component.css';
import TabFooter from "../../../components/core/TabFooter";
import ProfileCard from "../../../components/profiles/ProfileCard/ProfileCard";
import {Booking, Customer, Holiday, UpcomingEvent} from "../../../models";
import IconButton from "../../../components/common/IconButton/IconButton";
import {notifications} from "ionicons/icons";
import BookingModal from "../../../components/bookings/BookingModal/BookingModal";
import UpcomingEventsSection from "../../../components/events/UpcomingEventsSection";
import UpcomingHolidaysSection from "../../../components/holidays/UpcomingHolidaysSection";
import ReadOnlyBanner from "../../../components/core/ReadOnlyBanner";

type Props = {
    customer?: Customer | null;
    doRefresh: (event: CustomEvent) => void;
    refresherRef: RefObject<HTMLIonRefresherElement> | ((ref: HTMLIonRefresherElement | null) => void);

    selectedBooking?: Booking;
    setSelectedBooking: (booking?: Booking) => void;

    canEditProfile: boolean;

    upcomingEvents: UpcomingEvent[];
    upcomingHolidays: Holiday[];

    onEditProfileClicked: (profileId: number, event: React.MouseEvent<HTMLIonCardTitleElement, MouseEvent>) => void;
};

export const HomePage: React.FC<Props> = props => {
    const {
        customer,
        doRefresh,
        refresherRef,

        selectedBooking,
        setSelectedBooking,
        upcomingEvents,
        upcomingHolidays,
    } = props;

    return (
        <Page className={"home-page"}
              title={undefined}
              footer={customer && <TabFooter activeRoute={'/home'} customer={customer}/>}
              showMenuButton={true}
              showBackButton={false}
              showLoading={false}
              doRefresh={doRefresh}
              refresherRef={refresherRef}
              topRightButton={!customer?.accountReadOnly && <IconButton icon={notifications} slot="end" routerLink={"/notifications"}/>}
        >

            <ReadOnlyBanner />

            <div className="header-logo-wrapper ion-text-center">
                <IonImg className="header-logo"
                        src={customer && customer.company?.appLogoUrl ? customer.company.appLogoUrl : '/assets/logo.png'}
                />
            </div>

            <UpcomingEventsSection events={upcomingEvents} />
            <UpcomingHolidaysSection holidays={upcomingHolidays} />

            {
                customer?.profiles && customer.profiles.map((profile) => (
                    <ProfileCard
                        key={`profile-card-${profile.id}`}
                        customer={customer}
                        profile={profile}
                        setSelectedBooking={setSelectedBooking}
                    />
                ))
            }

            {customer && (
                <BookingModal
                    isOpen={!!selectedBooking}
                    onClose={() => { setSelectedBooking(undefined); }}
                    company={customer.company}
                    booking={selectedBooking}
                />
            )}
        </Page>
    );
};
